// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__iKXOw","info":"UpdateTermsInfo_info__15fcy"};